import React, { useState, useEffect, useContext, useCallback, useRef } from 'react';
import Image from 'next/image';
import { LocationContext } from '../../../context/LocationContext';
import { LoadingCover } from '../../commons/LoadingCover';
import { SystemError } from '../../error/SystemError';
import { SignUpForm } from './SignUpForm';
import { googleApiKey, s3Static } from '../../../utils/constants';
import { uploadImage } from '../../../api/user/post-api';
import { loginState } from '../../../api/user/login-state';
import { updateAccount } from '../../../api/user/user-account-api';
import  { useRouter } from 'next/router';
import Script from 'next/script';
import { motion } from 'framer-motion';
import { Camera, User, Calendar, FileText, SkipForward, Save, Loader2 } from 'lucide-react';

export const SignUpLayout = () => {
    const accountType = "General";
    const currentDate = new Date();
    const router = useRouter();
    
    const file = useRef('')
    
    const [ isMoreInfo, setIsMoreInfo ] = useState(false); 
    const [ isMainForm, setIsMainForm ] = useState(true);
    const [ userId, setUserId ] = useState("");  
    const [ formValues, setFormValues] = useState({ firstName: "", lastName: "", emailId: "", password: "", confirmPassword: "", countryName: ""});
    const [ moreInfoValues, setMoreInfoValues] = useState({ gender: "", category: "", professionalType: "", birthDate: currentDate.toLocaleString( 'sv', { timeZoneName: 'short' } ).substring(0,10), description: "Hi"});
    const [ isSubmit, setIsSubmit ] = useState(false);
    const [ formErrors, setFormErrors ] = useState({});
    const [ isLoading, setIsLoading ] = useState(false);
    const [ isSystemError, setIsSystemError ] = useState(false);
    const [ errorContent, setErrorContent ]  = useState({'header': "", 'body': ""}); 
    const [ isShowFile, setIsShowFile ] = useState(false);
    const [ profilePicture, setprofilePicture ] = useState("");    
    const [ isLoadGoogleMap, setIsLoadGoogleMap ] = useState(false)

    const { countryName, countryCd, countryCurrCd, countryTelCd, location, userLatitude, userLongitude, getUserLocationDetails } = useContext(LocationContext);    

    const handleMoreInfoChange = (e) => {
        const { name, value } = e.target;
        setMoreInfoValues({...moreInfoValues, [name]: value});
    }

    const handleMoreInfoSubmit = (e) => {
        e.preventDefault();
        setFormErrors(validateForm(setMoreInfoValues));
        setIsSubmit(true);
    }

    const skipMoreInfo = () => {
        setIsLoading(true)
        router.push("/home")
    }

    const validateForm = ( values ) => {  
        const errors = {};
        return errors;
    }

    const addProfilePicture = async() => {
        try{
            await uploadImage(file.current, userId, formValues.firstName + " " + formValues.lastName, "Profile Picture", "Profile", "Public", "strings", "My new Profile Picture");
        } catch (error){
            console.log(error);
            setErrorContent({'header': "Error uploading image", 'body': "Please try again. If problem persists, contact us at support@stringssg.com"});
            setIsSystemError(true);
            setIsLoading(false);
            return;
        }
    }

    const handleFileChange =(e) => {
        if(e.target.files.length == 0) return;
        let files = e.target.files;
        file.current = files[files.length-1];
        setIsShowFile(true);
        let reader = new FileReader();
        reader.onload = (e) => {
            setprofilePicture(e.target.result);
        }
        reader.readAsDataURL(file.current);
        if(file.current.size > 10485760){
            setErrorContent({'header': "File size exceeded", 'body': "Please try again with a file size less than 10MB."});
            setIsSystemError(true);
            return;
        } else {
            addProfilePicture();
        };
    }   

    const getUserId = async() => {
        try{
            let loginStateResponse = await loginState();    
            setUserId(loginStateResponse.id); 
        } catch (error){
            console.log(error);
            setErrorContent({'header': "Cannot get UserId", 'body': "Please try again. If problem persists, contact us at support@stringssg.com"});
            setIsSystemError(true);
            return;
        }
    }

    const addMoreInfo = useCallback(async() => {
        try {
            await updateAccount(
                  formValues.firstName
                , formValues.lastName
                , accountType
                , "Public"
                , moreInfoValues.category
                , moreInfoValues.professionalType
                , moreInfoValues.gender
                , moreInfoValues.birthDate
                , moreInfoValues.description
                , userId
                , countryName
                , countryCd
                , countryCurrCd
                , countryTelCd
                , "N"
                , location
                , userLatitude
                , userLongitude
            )  
            setIsSubmit(false);
            setIsLoading(true)
            router.push("/home")
                     
        } catch (error){
            console.log(error);
            setErrorContent({'header': "Account Update Error", 'body': "Please try again. If problem persists, contact us at support@stringssg.com"});
            setIsSystemError(true);
            setIsLoading(false);
            setIsSubmit(false);
            return;
        }
    }, [  formValues
        , accountType
        , moreInfoValues
        , userId
        , countryName
        , countryCd
        , countryCurrCd
        , countryTelCd
        , location
        , userLatitude
        , userLongitude
        , router    
    ])

    const goToMoreInfo = () => {
        globalThis.scrollTo({ top: 0 });
        setIsMainForm(false);
        setIsMoreInfo(true);
    }

    useEffect(() => {
        if(Object.keys(formErrors).length == 0 && isSubmit){
            addMoreInfo();
        } else {
            setIsSubmit(false);
        }
    }, [formErrors, isSubmit, addMoreInfo])

    useEffect(() => {
       if (!isMoreInfo) return;
       getUserId();
    }, [isMoreInfo])

    useEffect(() => {  
        if(typeof google == "undefined") return
        setIsLoadGoogleMap(true)
    }, [setIsLoadGoogleMap])

    useEffect(() => {
        if(!isLoadGoogleMap) return;
        getUserLocationDetails()
    }, [isLoadGoogleMap, getUserLocationDetails])

    return (
        <>
            <div className="max-w-md mx-auto">
                <motion.div 
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.4 }}
                    className="bg-white rounded-3xl shadow-xl border border-gray-100 overflow-hidden"
                >
                    {isMainForm && (
                        <SignUpForm 
                            goToMoreInfo={goToMoreInfo} 
                            formValues={formValues} 
                            setFormValues={setFormValues} 
                            accountType={accountType}
                        />
                    )}
                    
                    {isMoreInfo && (   
                        <>
                            {/* Header */}
                            <div className="px-6 pt-8 pb-4 text-center">
                                <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-green-100 flex items-center justify-center">
                                    <User size={28} className="text-green-500" />
                                </div>
                                <h1 className="text-2xl font-bold text-gray-900">Complete Your Profile</h1>
                                <p className="text-gray-500 mt-2 text-sm">Add more details to personalize your account</p>
                            </div>
                            
                            {/* Profile Picture Section */}
                            <div className='px-6 pb-4'>
                                <div className="flex items-center gap-4 p-4 bg-gray-50 rounded-2xl">
                                    <div className='relative h-20 w-20 shrink-0'>
                                        {!isShowFile ? (
                                            <Image 
                                                className='rounded-full border-2 border-gray-200'
                                                src={s3Static + "default-profile-pic.png"}
                                                fill
                                                style={{objectFit: 'cover'}}
                                                quality={100}
                                                alt='profile picture'
                                            />
                                        ) : (
                                            <div 
                                                className='absolute h-full w-full rounded-full border-2 border-orange-300' 
                                                style={{
                                                    backgroundImage : "url(" + profilePicture +")",
                                                    backgroundRepeat: "no-repeat",    
                                                    backgroundSize: "cover",
                                                    backgroundPosition: "center"
                                                }}
                                            />
                                        )}
                                    </div>
                                    <div className="flex-1">
                                        <label className="inline-flex items-center gap-2 px-4 py-2 bg-white border border-gray-200 rounded-xl text-orange-600 font-medium text-sm cursor-pointer hover:bg-orange-50 transition-colors">
                                            <Camera size={16} />
                                            Upload Photo
                                            <input 
                                                className='hidden'
                                                type="file" 
                                                name="photo"
                                                accept="image/*"
                                                capture={false}
                                                onChange={handleFileChange}
                                            />                                        
                                        </label>
                                        <p className='text-xs text-gray-400 mt-1'>Max file size 10MB</p>
                                    </div>
                                </div>
                            </div>

                            {/* More Info Form */}
                            <form className="px-6 pb-6" onSubmit={handleMoreInfoSubmit}>
                                <div className='space-y-4'>              
                                    {/* Gender */}
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Gender
                                        </label>
                                        <select 
                                            className="w-full h-12 px-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-gray-900 focus:outline-none focus:ring-2 focus:ring-orange-500/20 focus:border-orange-400 transition-all"
                                            name="gender" 
                                            value={moreInfoValues.gender} 
                                            onChange={handleMoreInfoChange} 
                                            required
                                        >
                                            <option value="">Select gender</option>
                                            <option>Male</option>
                                            <option>Female</option>
                                            <option>Other</option>
                                        </select>
                                    </div>

                                    {/* Date of Birth */}
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            Date of Birth
                                        </label>
                                        <div className="relative">
                                            <div className="absolute left-3 top-1/2 -translate-y-1/2">
                                                <Calendar size={18} className="text-gray-400" />
                                            </div>
                                            <input 
                                                type="date" 
                                                value={moreInfoValues.birthDate} 
                                                max={new Date().toLocaleString( 'sv', { timeZoneName: 'short' } ).substring(0,10)}
                                                className="w-full h-12 pl-10 pr-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-gray-900 focus:outline-none focus:ring-2 focus:ring-orange-500/20 focus:border-orange-400 transition-all" 
                                                name="birthDate" 
                                                onChange={handleMoreInfoChange} 
                                                required
                                            />
                                        </div>
                                    </div>

                                    {/* About */}
                                    <div>
                                        <label className="block text-sm font-medium text-gray-700 mb-2">
                                            About You
                                        </label>
                                        <div className="relative">
                                            <div className="absolute left-3 top-3">
                                                <FileText size={18} className="text-gray-400" />
                                            </div>
                                            <textarea
                                                rows="3"
                                                className="w-full pl-10 pr-4 py-3 bg-gray-50 border border-gray-200 rounded-xl text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-orange-500/20 focus:border-orange-400 transition-all resize-none"
                                                placeholder="Tell us a bit about yourself..."
                                                name="description" 
                                                value={moreInfoValues.description} 
                                                onChange={handleMoreInfoChange}
                                                required
                                            />
                                        </div>
                                    </div>
                                </div>				

                                {/* Action Buttons */}
                                <div className='mt-6 flex gap-3'>   
                                    <button 
                                        type="button" 
                                        onClick={skipMoreInfo}
                                        className="flex-1 flex items-center justify-center gap-2 py-3 bg-gray-100 text-gray-600 font-medium rounded-xl hover:bg-gray-200 transition-colors"
                                    >
                                        <SkipForward size={18} />
                                        Skip
                                    </button>                         
                                    <motion.button 
                                        whileTap={{ scale: 0.98 }}
                                        className="flex-1 flex items-center justify-center gap-2 py-3 bg-linear-to-r from-orange-500 to-amber-500 text-white font-medium rounded-xl shadow-lg shadow-orange-500/25 hover:shadow-xl hover:shadow-orange-500/30 disabled:opacity-50 transition-all" 
                                        type="submit" 
                                        disabled={isLoading}
                                    >
                                        {isLoading ? <Loader2 size={18} className="animate-spin" /> : <Save size={18} />}
                                        Save
                                    </motion.button>                 
                                </div>                                                    
                            </form>
                        </>
                    )}
                    
                    {isSystemError && <SystemError errorContent={errorContent} setIsSystemError={setIsSystemError}/>}
                    {isLoading && <LoadingCover/>}
                </motion.div>
            </div>
            
            {!isLoadGoogleMap && (
                <Script
                    id="google-maps"
                    src={`https://maps.googleapis.com/maps/api/js?key=${googleApiKey}&loading=async&language=en&libraries=places&callback=Function.prototype`}
                    strategy="afterInteractive"
                    onLoad={() => setIsLoadGoogleMap(true)}
                />
            )}
        </>        
    )
}
